import { CapacitorGetPlatform } from "./constants";
export { CapacitorGetPlatform } from "./constants";

export * from "./constants";

export const SharedConstants = [CapacitorGetPlatform];
